import {
  API_CREDENTIALS,
  AUDIT_LOGS,
  COMPANY_PROFILE,
  DASHBOARD,
  EDIT_COMPANY_PROFILE,
  INVOICE_LIST,
  PRICING,
  ROLES,
  ROLE_FEATURE,
  USER_FEATURE,
  USERS,
} from "@constants/internal-route.constant";
import { Access, isAllowed } from "./access";
import { AppRouteList } from "./site-msp/app.routes";

/**
 * The console sidebar. Items carry NO gate of their own: each one is gated by the route it opens
 * (`routeCode` / `adminOnly` in app.routes.ts), so the menu and the page can never disagree.
 */
export interface NavItem {
  label: string;
  /** Bootstrap Icons class, e.g. "bi-people". */
  icon: string;
  to?: string;
  /** Other path prefixes that should mark this item active (detail pages, edit pages). */
  also?: string[];
  children?: NavItem[];
}

export const NAV: NavItem[] = [
  { label: "Dashboard", icon: "bi-speedometer2", to: DASHBOARD },
  { label: "Modules Pricing", icon: "bi-tags", to: PRICING },
  {
    label: "Access",
    icon: "bi-shield-lock",
    children: [
      { label: "Users", icon: "bi-people", to: USERS, also: ["/users/"] },
      { label: "Roles", icon: "bi-person-badge", to: ROLES },
      { label: "Role permission", icon: "bi-ui-checks-grid", to: ROLE_FEATURE },
      { label: "User permission", icon: "bi-person-check", to: USER_FEATURE },
      { label: "API credentials", icon: "bi-key", to: API_CREDENTIALS },
    ],
  },
  {
    label: "Audits",
    icon: "bi-journal-check",
    children: [{ label: "Audit logs", icon: "bi-clock-history", to: AUDIT_LOGS }],
  },
  { label: "Billing", icon: "bi-receipt", to: INVOICE_LIST, also: ["/invoice/"] },
  { label: "Company", icon: "bi-building", to: COMPANY_PROFILE, also: [EDIT_COMPANY_PROFILE] },
];

const routeFor = (to: string) => AppRouteList.find((r) => r.link === to);

/** The menu as this user may see it: ungranted items dropped, and groups left empty dropped too. */
export const visibleNav = (access: Access): NavItem[] =>
  NAV.map((item) =>
    item.children ? { ...item, children: item.children.filter((c) => isAllowed(routeFor(c.to!), access)) } : item
  ).filter((item) => (item.children ? item.children.length > 0 : isAllowed(routeFor(item.to!), access)));

export const isActive = (item: NavItem, pathname: string): boolean =>
  (!!item.to && pathname === item.to) ||
  !!item.also?.some((p) => pathname.startsWith(p)) ||
  !!item.children?.some((c) => isActive(c, pathname));
